$(function () {
    // DODAJE ROZWIJANIE EKSTRAKLAS TABLE NA WKS

    const wksExtraclassBody = $('[data-wks-extraclass-body]');
    const wksExtraclassTr = $('[data-wks-extraclass-tr]');
    const wksExtraclassShowMore = $('[data-wks-show-extraclass]');

    wksExtraclassTr.slice(6).hide();

    if (wksExtraclassTr.length > 6) {

        wksExtraclassShowMore.click(function (e) {
            e.preventDefault();

            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {
                wksExtraclassBody.removeClass('addShadow');
                $(this).text('Pokaż mniej').attr('aria-expanded', 'true');
            } else {
                wksExtraclassBody.addClass('addShadow');
                $(this).text('Rozwiń wszystkie').attr('aria-expanded', 'false');
            }

            showHideWksExtraclass();
        });

        function showHideWksExtraclass() {
            wksExtraclassTr.slice(6).toggle();

            let wksExtraclassTrCount = wksExtraclassTr.length;
            let isVisible = $(wksExtraclassTrCount).is(":visible") ? true : false;

            if (isVisible) {
                $(wksExtraclassTrCount).hide();
            } else {
                $(wksExtraclassTrCount).show();
            }
        }
    }
});


window.onload = function () {
    $(document).ready(function () {

        // WKS HERO SLIDER
        $("[data-hero-wks-slider]").each(function () {
            var sliderId = $(this).attr("id");
            var splide = new Splide("#" + sliderId, {
                perPage: 1,
                perMove: 1,
                pagination: true,
                arrows: true,
                interval: 6000,
                height: 700,
                breakpoints: {
                    1199: {
                        height: 500,
                    },
                    991: {
                        height: 500,
                    },
                    767: {
                        height: 500,
                    },
                    479: {
                        height: 500,
                    },
                },
            }).mount();
        });

        // SLIDER NAJBLIŻSCZE MECZE ŚLĄSKA
        $("[data-uncomingmatches-wks-slider]").each(function () {
            var sliderId = $(this).attr("id");
            var splide = new Splide("#" + sliderId, {
                perPage: 3,
                perMove: 1,
                pagination: true,
                arrows: true,
                interval: 6000,
                gap: 16,
                breakpoints: {
                    991: {
                        perPage: 2,
                        arrows: true,
                    },
                    767: {
                        perPage: 2,
                        arrows: true,
                    },
                    479: {
                        perPage: 1,
                        arrows: true,
                    },
                },
            }).mount();
        });

        // WKS SPONSORS SLIDER
        $("[data-wks-sponsors-slider]").each(function () {
            var sliderId = $(this).attr("id");
            var splide = new Splide("#" + sliderId, {
                perPage: 3,
                perMove: 1,
                arrows: true,
                pagination: false,
                interval: 6000,
                gap: 16,
                breakpoints: {
                    1199: {
                        arrows: true,
                        pagination: false,
                    },
                    991: {
                        arrows: true,
                        pagination: false,
                    },
                    767: {
                        pagination: false,
                        arrows: true,
                        perPage: 2,
                    },
                    479: {
                        arrows: true,
                        pagination: false,
                        perPage: 1,
                    },
                },
            }).mount();
        });

    });
}